import type { GraphQlServiceType } from '#@/platform/networking/types/serviceType'

export function getServiceUrl(_service: GraphQlServiceType): string {
  throw new Error('getServiceUrl has not been implemented for this platform')
}
